var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    clipPath: "url(#clip0_2812_4787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.06641 24.7008C1.06523 28.9017 2.17148 33.0037 4.275 36.6192L0.865234 48.9723L13.6059 45.6576C17.1297 47.5611 21.078 48.5585 25.0902 48.5587H25.1008C38.3459 48.5587 49.1277 37.8643 49.1334 24.7196C49.1359 18.35 46.6383 12.3605 42.1004 7.85427C37.5633 3.34845 31.5291 0.8657 25.0998 0.862793C11.8531 0.862793 1.07207 11.5566 1.0666 24.7008",
    fill: "url(#paint0_linear_2812_4787)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.208984 24.693C0.207617 29.0452 1.35352 33.2938 3.53203 37.0388L0 49.8347L13.1975 46.4012C16.8338 48.3684 20.9279 49.4056 25.0939 49.4072H25.1047C38.825 49.4072 49.9941 38.3281 50 24.7128C50.0023 18.1143 47.4148 11.9095 42.7148 7.24186C38.0143 2.57481 31.7643 0.00271318 25.1047 0C11.382 0 0.214453 11.0775 0.208984 24.693ZM8.06855 36.3938L7.57578 35.6176C5.5043 32.3494 4.41094 28.5727 4.4125 24.6946C4.4168 13.3777 13.6988 4.17054 25.1125 4.17054C30.6398 4.17287 35.8344 6.31085 39.7414 10.1899C43.6482 14.0694 45.798 19.2264 45.7967 24.7112C45.7916 36.0281 36.5094 45.2364 25.1047 45.2364H25.0965C21.383 45.2345 17.741 44.245 14.5648 42.375L13.809 41.9302L5.97734 43.9676L8.06855 36.3938Z",
    fill: "url(#paint1_linear_2812_4787)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.8828 14.3698C18.4168 13.3421 17.9264 13.3213 17.4832 13.3033C17.1203 13.2878 16.7055 13.289 16.291 13.289C15.8762 13.289 15.2021 13.4438 14.6324 14.0611C14.0621 14.6789 12.4551 16.1719 12.4551 19.2085C12.4551 22.2454 14.6842 25.18 14.9949 25.5923C15.3061 26.0037 19.2982 32.4347 25.6209 34.9087C30.8756 36.9647 31.9449 36.5558 33.0854 36.4527C34.226 36.35 36.7658 34.9601 37.284 33.5188C37.8025 32.0777 37.8025 30.8424 37.6471 30.5843C37.4916 30.3271 37.0768 30.1727 36.4547 29.8642C35.8324 29.5554 32.7742 28.0622 32.2041 27.8562C31.6338 27.6504 31.2191 27.5477 30.8043 28.1657C30.3895 28.7828 29.1982 30.1727 28.8352 30.5843C28.4725 30.9969 28.1094 31.0483 27.4875 30.7395C26.865 30.4298 24.8617 29.7789 22.485 27.6764C20.6357 26.0403 19.3873 24.02 19.0244 23.4019C18.6615 22.7849 18.9855 22.4504 19.2975 22.1428C19.577 21.8663 19.9197 21.4221 20.2311 21.0618C20.5412 20.7014 20.6447 20.4442 20.8521 20.0326C21.0598 19.6205 20.9559 19.2601 20.8006 18.9514C20.6447 18.6426 19.4359 15.5901 18.8828 14.3698Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2812_4787",
    x1: 2414.27,
    y1: 4811.81,
    x2: 2414.27,
    y2: 0.862793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2812_4787",
    x1: 2500,
    y1: 4983.47,
    x2: 2500,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2812_4787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappFilled);
export default __webpack_public_path__ + "static/media/whatsapp-filled.2ace90f01266bfbd59d21e7a567a9666.svg";
export { ForwardRef as ReactComponent };